import React from 'react'
import Svg from '../../Svg'

export const MortgageCoachFullLogoSvg = props => (
  <Svg {...props} x='0px' y='0px' viewBox='0 0 833.6 112'>
    <path
      d='M38.8,36.9c6.1,0,12.1,1.5,17.5,4.5c5.4,2.9,9.9,7.2,13.2,12.4c3.3-5.2,7.8-9.4,13.2-12.4
      c5.4-2.9,11.4-4.5,17.5-4.5c2.1,0,4.1,0.2,6.1,0.6c-0.3-9.4-4.3-18.3-11-24.9C88.5,6.1,79.4,2.4,70,2.4c-9.4,0-18.5,3.6-25.2,10.1
      C38,19,34,27.9,33.7,37.3C35.4,37.1,37.1,36.9,38.8,36.9z'
      fill='#D8D8D8'
    />
    <path
      d='M33.6,38.6c0-0.4,0-0.8,0-1.2c-6,0.9-11.8,3.2-16.6,6.9c-4.9,3.7-8.8,8.5-11.3,14c-2.5,5.5-3.6,11.6-3.2,17.7
      C3,82,4.9,87.9,8.2,93c3.3,5.1,7.9,9.3,13.2,12.2c5.4,2.9,11.4,4.4,17.5,4.4c6.1,0,12.1-1.6,17.4-4.6c5.3-3,9.8-7.2,13.1-12.4
      C66,87.2,64,80.8,63.7,74.3c-8.4-1.5-16-5.9-21.5-12.4C36.6,55.4,33.6,47.1,33.6,38.6z'
      fill='#D8D8D8'
    />
    <path
      d='M106.3,37.5c0,0.4,0,0.7,0,1.1c0,8.7-3.2,17.1-8.9,23.7c-5.7,6.6-13.6,10.9-22.2,12.2
      c-0.3,6.5-2.3,12.7-5.8,18.2c3.2,5.1,7.7,9.3,13,12.3c5.3,3,11.2,4.5,17.3,4.6c6.1,0.1,12-1.4,17.4-4.2c5.4-2.8,9.9-6.9,13.3-12
      c3.4-5,5.4-10.8,6-16.9c0.5-6-0.4-12.1-2.8-17.7c-2.4-5.6-6.1-10.4-10.9-14.2C117.8,41,112.2,38.5,106.3,37.5L106.3,37.5z'
      fill='#D8D8D8'
    />
    <path
      d='M192.4,106.5h-8.7L168,23.3h-0.3v83.2H160V7.2h11.5l16.3,87.5h0.3l16.5-87.5h11.6v99.2h-7.7V22.5h-0.3
      L192.4,106.5z'
      fill='#D8D8D8'
    />
    <path
      d='M230.2,24.9c0-5.1,2-10,5.6-13.5c3.6-3.6,8.5-5.6,13.5-5.6c5.1,0,10,2,13.5,5.6c3.6,3.6,5.6,8.5,5.6,13.5v64
      c0,5.1-2,10-5.6,13.5c-3.6,3.6-8.5,5.6-13.5,5.6c-5.1,0-10-2-13.5-5.6c-3.6-3.6-5.6-8.5-5.6-13.5V24.9z M237.9,88.9
      c0,3,1.2,6,3.4,8.1c2.2,2.2,5.1,3.4,8.1,3.4c3,0,6-1.2,8.1-3.4c2.2-2.2,3.4-5.1,3.4-8.1v-64c0-3-1.2-6-3.4-8.1
      c-2.2-2.2-5.1-3.4-8.1-3.4c-3,0-6,1.2-8.1,3.4c-2.2,2.2-3.4,5.1-3.4,8.1V88.9z'
      fill='#D8D8D8'
    />
    <path
      d='M320,106.5h-7.7V73.6c0-1.7-0.3-3.4-1-5c-0.6-1.6-1.6-3-2.8-4.2c-1.2-1.2-2.6-2.2-4.2-2.8c-1.6-0.6-3.3-1-5-1
      h-9.3v45.8h-7.7V7.2h16.9c5.5,0,10.7,2.2,14.5,6c3.9,3.9,6,9.1,6.1,14.5v12.3c0,3.3-0.8,6.5-2.3,9.5c-1.5,2.9-3.7,5.5-6.4,7.4
      c2.7,1.9,4.8,4.4,6.3,7.3c1.5,2.9,2.3,6.1,2.3,9.4L320,106.5z M299.4,53c1.7,0,3.4-0.3,5-1c1.6-0.6,3-1.6,4.2-2.8
      c1.2-1.2,2.2-2.6,2.8-4.2c0.6-1.6,1-3.3,1-5V27.8c0-1.7-0.3-3.4-1-5c-0.6-1.6-1.6-3-2.8-4.2c-1.2-1.2-2.6-2.2-4.2-2.8
      c-1.6-0.6-3.3-1-5-1h-9.3V53H299.4z'
      fill='#D8D8D8'
    />
    <path
      d='M362.7,14.9H349v91.6h-7.8V14.9h-13.8V7.2h35.3L362.7,14.9z'
      fill='#D8D8D8'
    />
    <path
      d='M391.2,55.6h19.1V108l-6.5-1.3v-3.4c-2.8,2.4-6.2,4-9.8,4.5c-3.6,0.5-7.4,0-10.7-1.5c-3.3-1.5-6.2-4-8.2-7
      c-2-3.1-3.1-6.7-3.1-10.3v-64c0-5.1,2-10,5.6-13.5c3.6-3.6,8.5-5.6,13.5-5.6c5.1,0,10,2,13.5,5.6c3.6,3.6,5.6,8.5,5.6,13.5v11.8
      l-7.7,0.9V24.9c0-3-1.2-6-3.4-8.1c-2.2-2.2-5.1-3.4-8.1-3.4c-3,0-6,1.2-8.1,3.4c-2.2,2.2-3.4,5.1-3.4,8.1v64c0,3,1.2,6,3.4,8.1
      c2.2,2.2,5.1,3.4,8.1,3.4c3,0,6-1.2,8.1-3.4c2.2-2.2,3.4-5.1,3.4-8.1V63.3h-11.5L391.2,55.6z'
      fill='#D8D8D8'
    />
    <path
      d='M461.4,106.5h-7.7l-4-25.4h-20.1l-3.8,25.4h-7.7l15.2-99.3h13L461.4,106.5z M430.7,73.4h17.8l-8.6-57.6h-0.2
      L430.7,73.4z'
      fill='#D8D8D8'
    />
    <path
      d='M489.1,55.6h19.1V108l-6.5-1.3v-3.4c-2.8,2.4-6.2,4-9.8,4.5c-3.6,0.5-7.4,0-10.7-1.5c-3.3-1.5-6.2-4-8.2-7
      c-2-3.1-3.1-6.7-3.1-10.3v-64c0-5.1,2-10,5.6-13.5c3.6-3.6,8.5-5.6,13.5-5.6c5.1,0,10,2,13.5,5.6c3.6,3.6,5.6,8.5,5.6,13.5v11.8
      l-7.7,0.9V24.9c0-3-1.2-6-3.4-8.1c-2.2-2.2-5.1-3.4-8.1-3.4c-3,0-6,1.2-8.1,3.4c-2.2,2.2-3.4,5.1-3.4,8.1v64c0,3,1.2,6,3.4,8.1
      c2.2,2.2,5.1,3.4,8.1,3.4c3,0,6-1.2,8.1-3.4c2.2-2.2,3.4-5.1,3.4-8.1V63.3h-11.5L489.1,55.6z'
      fill='#D8D8D8'
    />
    <path
      d='M529.1,14.9V53h17.8v7.8h-17.8v38h25.3v7.7h-33V7.2h31.8v7.7L529.1,14.9z'
      fill='#D8D8D8'
    />
    <path
      d='M593.9,40.5V24.9c0-3-1.2-6-3.4-8.1c-2.2-2.2-5.1-3.4-8.1-3.4c-3,0-6,1.2-8.1,3.4c-2.2,2.2-3.4,5.1-3.4,8.1v64
      c0,3,1.2,6,3.4,8.1c2.2,2.2,5.1,3.4,8.1,3.4c3,0,6-1.2,8.1-3.4c2.2-2.2,3.4-5.1,3.4-8.1V75.3h7.7v13.5c0.1,2.6-0.4,5.1-1.3,7.5
      c-0.9,2.4-2.3,4.6-4.1,6.4s-3.9,3.3-6.3,4.3c-2.4,1-4.9,1.5-7.4,1.5c-2.6,0-5.1-0.5-7.4-1.5c-2.4-1-4.5-2.5-6.3-4.3
      c-1.8-1.8-3.2-4-4.1-6.4c-0.9-2.4-1.4-4.9-1.3-7.5v-64c0.1-5,2.2-9.7,5.8-13.2c3.6-3.5,8.4-5.4,13.3-5.4c5,0,9.8,1.9,13.3,5.4
      c3.6,3.5,5.6,8.2,5.8,13.2v14.7L593.9,40.5z'
      fill='#D8D8D8'
    />
    <path
      d='M613.1,24.9c0-5.1,2-10,5.6-13.5c3.6-3.6,8.5-5.6,13.5-5.6s10,2,13.5,5.6c3.6,3.6,5.6,8.5,5.6,13.5v64
      c0,5.1-2,10-5.6,13.5c-3.6,3.6-8.5,5.6-13.5,5.6s-10-2-13.5-5.6c-3.6-3.6-5.6-8.5-5.6-13.5V24.9z M620.8,88.9c0,3,1.2,6,3.4,8.1
      c2.2,2.2,5.1,3.4,8.1,3.4s6-1.2,8.1-3.4c2.2-2.2,3.4-5.1,3.4-8.1v-64c0-3-1.2-6-3.4-8.1c-2.2-2.2-5.1-3.4-8.1-3.4s-6,1.2-8.1,3.4
      c-2.2,2.2-3.4,5.1-3.4,8.1V88.9z'
      fill='#D8D8D8'
    />
    <path
      d='M703.2,106.5h-7.7l-4-25.4h-20.1l-3.8,25.4h-7.7l15.1-99.3h13L703.2,106.5z M672.5,73.4h17.8l-8.6-57.6h-0.3
      L672.5,73.4z'
      fill='#D8D8D8'
    />
    <path
      d='M742.3,40.5V24.9c0-3-1.2-6-3.4-8.1s-5.1-3.4-8.1-3.4c-3.1,0-6,1.2-8.1,3.4c-2.2,2.2-3.4,5.1-3.4,8.1v64
      c0,3,1.2,6,3.4,8.1c2.2,2.2,5.1,3.4,8.1,3.4c3,0,6-1.2,8.1-3.4c2.2-2.2,3.4-5.1,3.4-8.1V75.3h7.7v13.5c0,5.1-2,10-5.6,13.5
      c-3.6,3.6-8.5,5.6-13.5,5.6s-10-2-13.5-5.6c-3.6-3.6-5.6-8.5-5.6-13.5v-64c0-5.1,2-10,5.6-13.5c3.6-3.6,8.5-5.6,13.5-5.6
      s10,2,13.5,5.6c3.6,3.6,5.6,8.5,5.6,13.5v14.7L742.3,40.5z'
      fill='#D8D8D8'
    />
    <path
      d='M800.6,7.2v99.2h-7.7V60.6h-23v45.8h-7.7V7.2h7.7V53h23V7.2H800.6z'
      fill='#D8D8D8'
    />
    <path
      d='M830.5,98.5c0.1,1.9-0.5,3.7-1.5,5.2c-1,1.6-2.4,2.8-4.1,3.5c-1.7,0.7-3.6,1-5.4,0.6c-1.8-0.3-3.5-1.2-4.8-2.5
      c-1.3-1.3-2.2-3-2.6-4.8c-0.4-1.8-0.2-3.7,0.5-5.4c0.7-1.7,1.9-3.2,3.5-4.2c1.6-1,3.4-1.6,5.2-1.5c1.2,0,2.4,0.2,3.5,0.7
      c1.1,0.4,2.1,1.1,3,2c0.9,0.8,1.5,1.8,2,3C830.2,96.1,830.5,97.3,830.5,98.5z M814.2,98.5c0,0.9,0.1,1.9,0.5,2.8
      c0.3,0.9,0.9,1.7,1.5,2.4c0.7,0.7,1.4,1.2,2.3,1.6c0.9,0.4,1.8,0.5,2.7,0.5c1.9-0.1,3.6-0.9,4.9-2.2c1.3-1.3,2-3.1,2-5
      c0-1.9-0.7-3.6-2-5c-1.3-1.3-3-2.1-4.9-2.2c-0.9,0-1.9,0.2-2.7,0.5c-0.9,0.4-1.7,0.9-2.3,1.6c-0.7,0.7-1.2,1.5-1.5,2.4
      C814.3,96.6,814.2,97.6,814.2,98.5z M819.9,103.2h-2.1v-9c1.1-0.2,2.3-0.3,3.5-0.3c1.1-0.1,2.1,0.2,3.1,0.7c0.3,0.2,0.5,0.6,0.7,0.9
      c0.2,0.3,0.2,0.7,0.2,1.1c0,0.5-0.2,1-0.6,1.4c-0.3,0.4-0.8,0.6-1.3,0.7v0.1c0.5,0.2,0.8,0.5,1.1,0.9c0.3,0.4,0.5,0.9,0.5,1.3
      c0.1,0.8,0.3,1.5,0.7,2.3h-2.2c-0.4-0.7-0.6-1.4-0.7-2.2c-0.2-1-0.7-1.4-1.9-1.4h-0.9V103.2z M819.9,98.1h1c1.2,0,2.1-0.4,2.1-1.3
      c0-0.9-0.6-1.4-1.9-1.4c-0.4,0-0.8,0-1.2,0.1V98.1z'
      fill='#D8D8D8'
    />
  </Svg>
)

export default MortgageCoachFullLogoSvg
